import { Route, Routes } from 'react-router-dom';

import CardPage from './pages/CardPage';
import ClaimPage from './pages/ClaimPage';
import ConsentPage from './pages/ConsentPage';
import NotFoundPage from './pages/NotFoundPage';
import SignupPage from './pages/SignupPage';
import { appVersion } from './version';

/**
 * Public-facing customer-signup web app for Barbridge.
 *
 * Routes (per spec §3):
 *   /c/:venueShortName     — coupon signup form
 *   /claim/:token          — magic-link landing → confirmation page
 *   /card/:signedToken     — Apple Wallet pass download / add-to-wallet page
 *   /legal/consent         — consent / privacy document
 *   /                      — minimal landing
 *   *                      — 404
 */
export default function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/c/:venueShortName" element={<SignupPage />} />
        <Route path="/claim/:token" element={<ClaimPage />} />
        <Route path="/card/:signedToken" element={<CardPage />} />
        <Route path="/legal/consent" element={<ConsentPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <footer className="version" aria-label="Build version">
        v{appVersion.version}
      </footer>
    </div>
  );
}

function Landing() {
  return (
    <main className="container">
      <h1>Barbridge</h1>
      <p>Scan the QR poster at a participating venue to claim your card.</p>
    </main>
  );
}
